module.exports = __webpack_public_path__ + "static/img/loginImg.4907031.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/loginImg.png
// module id = lNZr
// module chunks = 1